import {Component} from '@angular/core';

@Component({
    selector: 'spinner',
    standalone: true,
    templateUrl: './spinner.component.html',
})
export class SpinnerComponent {}
